import React from 'react';
import { aboutInfo } from '../mock';

export default function AboutSection() {
  return (
    <section className="relative w-full">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        {/* Image */}
        <div className="relative img-zoom h-[420px] lg:h-[640px]">
          <img src={aboutInfo.image} alt="Simpolo Office" className="w-full h-full object-cover" />
          {/* Years badge */}
          <div className="absolute top-8 right-8 md:top-12 md:right-12 bg-white text-[#7a1a2a] flex flex-col items-center justify-center w-32 h-32 md:w-40 md:h-40 rounded-full shadow-2xl border border-[#7a1a2a]/10">
            <div className="serif text-4xl md:text-5xl font-semibold leading-none">{aboutInfo.years}</div>
            <div className="text-[11px] tracking-[0.25em] uppercase mt-2 text-[#6b6b6b]">{aboutInfo.yearsLabel}</div>
          </div>
        </div>

        {/* Content */}
        <div className="flex items-center bg-white px-8 md:px-20 py-16 lg:py-0">
          <div className="max-w-xl">
            <div className="text-[11px] tracking-[0.4em] uppercase text-[#7a1a2a] mb-4">About Us</div>
            <h2 className="serif text-4xl md:text-5xl font-light leading-[1.15] text-[#1a1a1a] mb-6">
              {aboutInfo.title}
            </h2>
            <p className="text-[15px] leading-relaxed text-[#555] mb-8 font-light">
              {aboutInfo.description}
            </p>
            <a href="#" className="link-underline text-[#7a1a2a]">Know More <span aria-hidden>&rarr;</span></a>
          </div>
        </div>
      </div>
    </section>
  );
}
